import SignIn from "./SignIn";
import SignInHeader from "./components/SignInHeader";
import ReduxProvider from "./ReduxProvider";
import VideoBackground from "./components/VideoBackground";

export default function SignInPage() {
  return (
    <ReduxProvider>
      <div className="relative min-h-screen">
        <VideoBackground />
        <div className="relative z-20">
          <SignInHeader />
          <SignIn />
        </div>
      </div>
    </ReduxProvider>
  );
}
